<cm-test-container [testCases]="testCases" #testContainer>
    <iframe style="width: 100%; height: 100%" frameborder="0" #configuratorIframe></iframe
></cm-test-container>
